<template>
  <div class="wrap">
    <div class="now-wrap">
      <div
        v-if="currentType === 'month' && !isCurrent"
        class="button green"
        @click="handleCurrent('click')"
      >
        本月
      </div>
      <div
        v-if="currentType === 'week' && !isCurrent"
        class="button green"
        @click="handleCurrent('click')"
      >
        本周
      </div>
      <div
        v-if="currentType === 'day' && !isCurrent"
        class="button green"
        @click="handleCurrent('click')"
      >
        今日
      </div>
    </div>
    <div class="arrows-wrap">
      <div class="button" @click="handlePrev">
        <i class="el-icon-arrow-left"></i>
      </div>
      <p class="text">
        <span>{{ format(this.currentRangeStart) }}</span>
        <span v-if="currentType !== 'day'">
          - {{ format(this.currentRangeEnd) }}</span
        >
        <el-date-picker
          v-model="week_value"
          type="week"
          :clearable="false"
          value-format="yyyy-MM-dd"
          :picker-options="{ firstDayOfWeek: 1 }"
          @change="handleChangeTime"
        >
        </el-date-picker>
      </p>
      <div class="button" @click="handleNext">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="types-wrap" v-if="rangeType === 'all'">
      <el-radio-group v-model="currentType" @change="handleTypeChange">
        <el-radio-button label="month">月</el-radio-button>
        <el-radio-button label="week">周</el-radio-button>
        <el-radio-button label="day">日</el-radio-button>
      </el-radio-group>
    </div>
  </div>
</template>
<script>
import { PageModule } from "@/store/module/page";
import { dateFormat } from "@/utils/timeFormat";
export default {
  // rangeType:只有传all时会显示月周日的切换按钮
  // weekStartDay:周的开始日期，1为周一，7为周日
  // immediate:初始化时是否触发switch
  props: ["rangeType", "weekStartDay", "immediate"],
  data() {
    return {
      currentRangeStart: 0,
      currentRangeEnd: 0,
      currentType: "",
      isCurrent: true,
      cacheDate: {},
      week_value: "",
    };
  },
  created() {
    this.currentType = this.rangeType === "all" ? "month" : this.rangeType; //传all时默认为月
    const now = new Date();
    this.currentRangeStart = this.getStartTime(now); //获取当前时间段的开始
    this.currentRangeEnd = this.getEndTime(now); //获取当前时间段的结束
    const teacher = PageModule.pageInfo.teacherStoreDate;
    if (teacher.teacherTime) {
      this.currentRangeStart = teacher.teacherTime.startDate;
      this.currentRangeEnd = teacher.teacherTime.endDate;
      const cur = new Date().getTime();
      if (this.currentRangeStart <= cur && this.currentRangeEnd >= cur) {
        this.isCurrent = true;
      } else {
        this.isCurrent = false;
      }
      this.$emit("init", [
        teacher.teacherTime.startDate,
        teacher.teacherTime.endDate,
      ]);
      if (this.immediate) {
        this.$emit("switch", [
          teacher.teacherTime.startDate,
          teacher.teacherTime.endDate,
        ]);
      }
    } else {
      this.$emit("init", [this.getStartTime(now), this.getEndTime(now)]);
      if (this.immediate) {
        this.handleCurrent("");
      }
    }
    this.week_value = dateFormat(
      "YYYY-mm-dd",
      new Date(this.currentRangeStart).getTime()
    );
  },
  methods: {
    // 时间选择, 把时间组件隐藏,处理时间
    handleChangeTime(v) {
      if (this.currentType === "week") {
        this.currentRangeStart =
          new Date(this.week_value).getTime() + 6 * 24 * 3600 * 1000;
        this.currentRangeEnd =
          new Date(this.week_value).getTime() + 12 * 24 * 3600 * 1000;
      }
      this.handlePrev();
    },
    format(v) {
      const cur = new Date(v);
      return `${cur.getFullYear()}年${cur.getMonth() + 1}月${cur.getDate()}日`;
    },
    getStartTime(v) {
      let str = "";
      if (this.currentType === "month") {
        // 找1号
        str = `${v.getFullYear()}-${v.getMonth() + 1}-1 00:00:00`;
      } else if (this.currentType === "week") {
        let startDay;
        if (this.weekStartDay === "1") {
          // 找周一
          startDay = new Date(
            v.getTime() -
              (v.getDay() === 0 ? 6 : v.getDay() - 1) * 24 * 60 * 60 * 1000
          );
        } else {
          // 找周日
          startDay = new Date(v.getTime() - v.getDay() * 24 * 60 * 60 * 1000);
        }
        str = `${startDay.getFullYear()}/${
          startDay.getMonth() + 1
        }/${startDay.getDate()} 00:00:00`;
      } else if (this.currentType === "day") {
        // 找当天0点
        str = `${v.getFullYear()}/${v.getMonth() + 1}/${v.getDate()} 00:00:00`;
      }
      const res = new Date(str).getTime();
      return res;
    },
    getEndTime(v) {
      let str = "";
      if (this.currentType === "month") {
        // 找当月最后一日
        let m = v.getMonth();
        let y = v.getFullYear();
        if (m === 11) {
          m = 1;
          y = y + 1;
        } else {
          m = m + 2;
        }
        const next = new Date(
          new Date(`${y}/${m}/1`).getTime() - 24 * 60 * 60 * 1000
        );
        str = `${next.getFullYear()}-${
          next.getMonth() + 1
        }-${next.getDate()} 23:39:39`;
      } else if (this.currentType === "week") {
        let endDay;
        if (this.weekStartDay === "1") {
          // 找周日
          endDay = new Date(
            v.getTime() +
              (v.getDay() === 0 ? 0 : 7 - v.getDay()) * 24 * 60 * 60 * 1000
          );
        } else {
          // 找周六
          endDay = new Date(
            v.getTime() + (6 - v.getDay()) * 24 * 60 * 60 * 1000
          );
        }
        str = `${endDay.getFullYear()}/${
          endDay.getMonth() + 1
        }/${endDay.getDate()} 23:39:39`;
      } else if (this.currentType === "day") {
        // 找当天24点
        str = `${v.getFullYear()}/${v.getMonth() + 1}/${v.getDate()} 23:39:39`;
      }
      const res = new Date(str).getTime();
      return res;
    },
    handleCurrent(v) {
      const now = new Date();
      const start = this.getStartTime(now);
      const end = this.getEndTime(now);
      this.currentRangeStart = start;
      this.currentRangeEnd = end;
      this.$emit("switch", [start, end]);
      this.isCurrent = true;
      if (v === "click") {
        this.setWeekTime();
      }
      this.week_value = dateFormat(
        "YYYY-mm-dd",
        new Date(this.currentRangeStart).getTime()
      );
    },
    handlePrev() {
      const now = new Date(this.currentRangeStart);
      let target = new Date();
      if (this.currentType === "month") {
        let m = now.getMonth();
        let y = now.getFullYear();
        if (m === 0) {
          m = 12;
          y = y - 1;
        }
        target = new Date(`${y}/${m}/1`);
      } else if (this.currentType === "week") {
        target = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      } else if (this.currentType === "day") {
        target = new Date(now.getTime() - 24 * 60 * 60 * 1000);
      }
      const start = this.getStartTime(target);
      const end = this.getEndTime(target);
      this.currentRangeStart = start;
      this.currentRangeEnd = end;
      this.$emit("switch", [start, end]);
      const cur = new Date().getTime();
      if (start <= cur && end >= cur) {
        this.isCurrent = true;
      } else {
        this.isCurrent = false;
      }
      this.setWeekTime();
      this.week_value = dateFormat(
        "YYYY-mm-dd",
        new Date(this.currentRangeStart).getTime()
      );
    },
    setWeekTime() {
      this.cacheDate.startDate = this.currentRangeStart;
      this.cacheDate.endDate = this.currentRangeEnd;
      this.cacheDate.type = this.rangeType;
      this.cacheDate.morword = this.currentType;
      PageModule.SET_PAGE_INFO({
        name: "teacherStoreDate",
        key: "teacherTime",
        value: this.cacheDate,
      });
    },
    handleNext() {
      const now = new Date(this.currentRangeStart);
      let target = new Date();
      if (this.currentType === "month") {
        let m = now.getMonth();
        let y = now.getFullYear();
        if (m === 11) {
          m = 1;
          y = y + 1;
        } else {
          m = m + 2;
        }
        target = new Date(`${y}/${m}/1`);
      } else if (this.currentType === "week") {
        target = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
      } else if (this.currentType === "day") {
        target = new Date(now.getTime() + 24 * 60 * 60 * 1000);
      }
      const start = this.getStartTime(target);
      const end = this.getEndTime(target);
      this.currentRangeStart = start;
      this.currentRangeEnd = end;
      this.$emit("switch", [start, end]);
      const cur = new Date().getTime();
      if (start <= cur && end >= cur) {
        this.isCurrent = true;
      } else {
        this.isCurrent = false;
      }
      this.setWeekTime();
      this.week_value = dateFormat(
        "YYYY-mm-dd",
        new Date(this.currentRangeStart).getTime()
      );
    },
    handleTypeChange(e) {
      this.handleCurrent("");
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  display: flex;
  justify-content: center;
  line-height: 28px;
  align-items: center;
  .button {
    margin: 0 10px;
    border-radius: 4px;
    border: 1px solid #e7e8ea;
    padding: 0 10px;
    font-size: 12px;
    color: #5c5d5e;
    cursor: pointer;
    &.green {
      border-color: #38dabb;
      color: #38dabb;
    }
  }
  .now-wrap {
  }
  .arrows-wrap {
    .text {
      margin: 0 10px;
      font-size: 12px;
      color: #5c5d5e;
      position: relative;
    }
    display: inline-flex;
  }
  .types-wrap {
    /deep/ .el-radio-group {
      .el-radio-button {
        .el-radio-button__inner {
          padding: 7px 18px;
          &:hover {
            color: #07d1aa;
          }
        }
        &.is-active {
          .el-radio-button__inner {
            background-color: #07d1aa;
            border-color: #07d1aa;
            color: #ffffff;
            box-shadow: -1px 0 0 0 #07d1aa;
          }
        }
      }
    }
  }
}
/deep/.el-date-editor {
  width: 177px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  .el-input__inner {
    height: 30px;
    cursor: pointer;
  }
}
</style>
